import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ContractInboundPhone } from '../../_types/contract-inbound-phone';
import { ContractInboundPhonesService } from '../../_services/contracts-inbound-phones.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { ContractInboundMail } from '../../_types/contract-inbound-mail';
import { ContractInboundMailsService } from '../../_services/contracts-inbound-mails.service';
import { LoginService } from 'src/app/modules/login/login.service';

@Component({
    selector: 'app-inbound-mail-detail',
    templateUrl: './inbound-mail-detail.component.html',
    styleUrls: ['./inbound-mail-detail.component.scss'],
    standalone: false
})
export class ContractInboundMailDetailComponent {
  public contractInboundMailFormGroup!: RxFormGroup;

  public contractInboundMail: ContractInboundMail = new ContractInboundMail();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;


  constructor(
    private contractInboundMailsService: ContractInboundMailsService,
    private config: DynamicDialogConfig,
    private messageService: MessageService,
    private dynamicDialogRef: DynamicDialogRef,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {
    this.contractInboundMailFormGroup = this.formBuilder.formGroup<ContractInboundMail>(this.contractInboundMail) as RxFormGroup;
  }

  ngOnInit(): void {
    if (this.config.data.contractInboundMailId) {
      this.loadContractInboundMail(this.config.data.contractInboundMailId);
    } else {
      this.contractInboundMail.contractId = this.config.data.contractId;
    }
    this.allowWrite = this.loginService.hasPermission("COMPANIES.WRITE");
    this.allowDelete = this.loginService.hasPermission("COMPANIES.DELETE");
  }

  async loadContractInboundMail(id: string) {
    this.contractInboundMail = await firstValueFrom(this.contractInboundMailsService.get(id));
    this.contractInboundMailFormGroup.patchValue(this.contractInboundMail);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.contractInboundMailFormGroup);
    if (valid) {
      this.contractInboundMail = Object.assign(this.contractInboundMail, this.contractInboundMailFormGroup.value);

      await this.contractInboundMailsService.save(this.contractInboundMail).subscribe({
        next: (data) => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Correo guardado correctamente' });
          this.dynamicDialogRef.close();
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar el correo' });
        }
      });
    } else {
      document.getElementById('form')?.classList.add('formInvalid');
    }
  }
  cancel() {
    this.dynamicDialogRef.close();
  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el correo?",
      header: "Eliminar correo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.contractInboundMailsService.delete(this.contractInboundMail.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Correo eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }
}
